import React from 'react';
import { reduxForm } from 'redux-form';
import { EMPLOYEE_PAY_ROLLBACK_FORM } from 'src/constants/FormNames';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { ErrorsSection } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import styles from './RollbackEmployeePayModal.scss';
import { useTranslation } from 'react-i18next';

const PrepareRollbackEmployeePayModal = ({ submitting, submit, isOpen, errors, hideModal, employeePayId }) => {
  const { t } = useTranslation();
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, employeePayId }}>
      <CommonModal.Header hideModal={hideModal}>{t('features.EmployeePays.components.RollbackEmployeePayModal.Operation_confirmation')}</CommonModal.Header>
      <CommonModal.Body>
        <form className={styles.wrap}>
          <ErrorsSection errors={errors} />
          {t('features.EmployeePays.components.RollbackEmployeePayModal.Back_to_before_manual_input_question')}
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('features.EmployeePays.components.ExportPndModal.Cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.RollbackEmployeePayModal.Back_to_before_manual_input')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </CommonModal>
  );
};

const RollbackEmployeePayModal = reduxForm({
  form: EMPLOYEE_PAY_ROLLBACK_FORM
})(PrepareRollbackEmployeePayModal);

export default RollbackEmployeePayModal;
